export const fixToken = (token: string) => {
  let decodedToken = decodeURIComponent(token);
  decodedToken = decodedToken.replace(/ /g, '+');

  while (decodedToken.length % 4 !== 0) {
    decodedToken += '=';
  }

  return encodeURIComponent(decodedToken);
};
